export default "__VITE_ASSET__527b5a17__"